"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GleamCampaignToJSON = exports.GleamCampaignFromJSONTyped = exports.GleamCampaignFromJSON = void 0;
function GleamCampaignFromJSON(json) {
    return GleamCampaignFromJSONTyped(json, false);
}
exports.GleamCampaignFromJSON = GleamCampaignFromJSON;
function GleamCampaignFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'key': json['key'],
        'type': json['type'],
    };
}
exports.GleamCampaignFromJSONTyped = GleamCampaignFromJSONTyped;
function GleamCampaignToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'key': value.key,
        'type': value.type,
    };
}
exports.GleamCampaignToJSON = GleamCampaignToJSON;
